import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatsCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: BoxIcon;
}
export function StatsCard({
  title,
  value,
  change,
  trend,
  icon: Icon
}: StatsCardProps) {
  return <div className="rounded-xl p-6 bg-card border border-border hover:shadow-md hover:bg-[#fef5ee] transition-all" data-id="element-106">
      <div className="flex items-start justify-between mb-4" data-id="element-107">
        <div className="flex-1" data-id="element-108">
          <p className="text-sm font-medium text-muted-foreground" data-id="element-109">{title}</p>
        </div>
        <div className="h-10 w-10 rounded-lg bg-[#eb6641]/10 flex items-center justify-center" data-id="element-110">
          <Icon className="h-5 w-5 text-[#eb6641]" data-id="element-111" />
        </div>
      </div>
      <p className="text-3xl font-bold text-foreground mb-2" data-id="element-112">{value}</p>
      <p className="text-sm text-muted-foreground" data-id="element-113">{change}</p>
    </div>;
}